<template>
    <div class="main-wrapper">
        <Sidebar />
        <div class="page-wrapper">
            <Navbar />
            <div class="page-content">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from '../components/sidebar/SidebarAdmin.vue'
import Navbar from '../components/navbar/NavbarAdmin.vue'
export default {
    name: 'admin-layout',
    components: {
        Navbar,
        Sidebar
    }
}
</script>